import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrTabsComponent } from './pr-tabs.component';
import { PrTabsItemComponent } from './pr-tabs-item/pr-tabs-item.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [PrTabsComponent, PrTabsItemComponent],
  imports: [CommonModule, RouterModule],
  exports: [PrTabsComponent],
})
export class PrTabsModule {}
